import React from 'react';
import { Button } from './Button';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  className?: string;
  actionButtonText?: string;
  onActionButtonClick?: () => void;
  actionButtonVariant?: 'primary' | 'secondary' | 'outline' | 'danger';
  actionButtonIcon?: React.ReactNode;
  align?: 'left' | 'center';
}

export const PageHeader: React.FC<PageHeaderProps> = ({ 
  title, 
  subtitle, 
  children,
  className = '',
  actionButtonText,
  onActionButtonClick,
  actionButtonVariant = 'primary',
  actionButtonIcon,
  align = 'left'
}) => {
  const isCenter = align === 'center';
  return (
    <div className={`mb-8 ${className}`}>
      <div className={
        isCenter
          ? 'flex flex-col items-center text-center'
          : 'flex flex-col sm:flex-row sm:items-center sm:justify-between'
      }>
        <div className={isCenter ? '' : 'flex-1 min-w-0'}>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className={`mt-2 text-sm sm:text-base text-gray-600 dark:text-gray-300 ${isCenter ? '' : 'max-w-3xl'}`}>
              {subtitle}
            </p>
          )}
        </div>
        {!isCenter && (
          <div className="mt-4 sm:mt-0 sm:ml-4 flex-shrink-0">
            {actionButtonText && onActionButtonClick && (
              <Button
                variant={actionButtonVariant}
                onClick={onActionButtonClick}
                icon={actionButtonIcon}
              >
                {actionButtonText}
              </Button>
            )}
            {children}
          </div>
        )}
        {isCenter && (actionButtonText || children) && (
          <div className="mt-4">
            {actionButtonText && onActionButtonClick && (
              <Button
                variant={actionButtonVariant}
                onClick={onActionButtonClick}
                icon={actionButtonIcon}
              >
                {actionButtonText}
              </Button>
            )}
            {children}
          </div>
        )}
      </div>
    </div>
  );
}; 